import { useState, useEffect } from 'react';
import {
  Box, Container, Typography, Card, CardContent, CircularProgress, Chip, Alert,
  Table, TableBody, TableCell, TableHead, TableRow,
} from '@mui/material';
import { MenuBook } from '@mui/icons-material';
import axios from 'axios';

const API = process.env.REACT_APP_API_URL;
const hdrs = () => ({ Authorization: `Bearer ${localStorage.getItem('token')}` });

const statusColor = (s) => s === 'Assigned' ? 'info' : s === 'Returned' ? 'success' : 'error';

export default function ParentBooks() {
  const [loans, setLoans] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios.get(`${API}/api/library/my-books`, { headers: hdrs() })
      .then(r => setLoans(r.data))
      .catch(() => setLoans([]))
      .finally(() => setLoading(false));
  }, []);

  if (loading) return <Box textAlign="center" py={8}><CircularProgress /></Box>;

  // group by learner
  const byLearner = {};
  loans.forEach(l => { (byLearner[l.borrowerName || l.borrowerRef] = byLearner[l.borrowerName || l.borrowerRef] || []).push(l); });
  const names = Object.keys(byLearner);

  const overdue = (l) => l.status === 'Assigned' && l.dueDate && new Date(l.dueDate) < new Date();

  return (
    <Container maxWidth="md" sx={{ px: { xs: 1, sm: 2, md: 3 } }}>
      <Box py={{ xs: 2, sm: 3 }}>
        <Box display="flex" alignItems="center" gap={1} mb={2}>
          <MenuBook color="primary" />
          <Typography variant="h5" fontWeight={800}>Library Books</Typography>
        </Box>

        {names.length === 0 ? (
          <Alert severity="info">No library books are currently recorded against your children.</Alert>
        ) : names.map(name => (
          <Card key={name} elevation={2} sx={{ mb: 2, borderRadius: 2 }}>
            <CardContent>
              <Typography variant="h6" fontWeight={700} mb={1}>{name}</Typography>
              <Table size="small">
                <TableHead><TableRow>
                  <TableCell><strong>Book</strong></TableCell><TableCell><strong>Issued</strong></TableCell>
                  <TableCell><strong>Due</strong></TableCell><TableCell><strong>Status</strong></TableCell>
                </TableRow></TableHead>
                <TableBody>
                  {byLearner[name].map(l => (
                    <TableRow key={l.loanNo} hover>
                      <TableCell>{l.bookTitle}</TableCell>
                      <TableCell>{l.issueDate ? new Date(l.issueDate).toLocaleDateString() : ''}</TableCell>
                      <TableCell>{l.dueDate ? new Date(l.dueDate).toLocaleDateString() : ''}</TableCell>
                      <TableCell>
                        <Chip size="small" variant="outlined" color={overdue(l) ? 'error' : statusColor(l.status)}
                          label={overdue(l) ? 'Overdue' : l.status} />
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </CardContent>
          </Card>
        ))}
      </Box>
    </Container>
  );
}
